module.exports = {
  init: function () {
    const dataModules = document.querySelectorAll("[data-module]");
    for (const dataModule of dataModules) {
      this.modules[dataModule.dataset.module] &&
        new this.modules[dataModule.dataset.module].default(dataModule);
    }
  },
  modules: {
    Blob: require("./Blob/Blob"),
    TestimonialsCarousel: require("./TestimonialsCarousel/TestimonialsCarousel"),
    Carousel: require("./Carousel/Carousel"),
    EqualHeight: require("./EqualHeight/EqualHeight"),
    GlobalHeader: require("./GlobalHeader/GlobalHeader"),
    LogoGrid: require("./LogoGrid/LogoGrid"),
    Popup: require("./Popup/Popup"),
    ResourcesFilter: require("./ResourcesFilter/ResourcesFilter"),
    Rolodex: require("./Rolodex/Rolodex"),
    StickyNav: require("./StickyNav/StickyNav"),
    Tabs: require("./Tabs/Tabs"),
    Tables: require("./Tables/Tables"),
    ThreeCTAs: require("./ThreeCTAs/ThreeCTAs"),
    BlogFilter: require("./BlogFilter/BlogFilter"),
    Accordion: require("./Accordion/Accordion"),
    PartnersGrid: require("./PartnersGrid/PartnersGrid"),
    PromotedContent: require("./PromotedContent/PromotedContent"),
    TestimonialsStats: require("./TestimonialsStats/TestimonialsStats"),
    Status: require("./Status/Status"),
  },
};
